import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import isScript from "../../hooks/isScript";
import { getCookieValue } from "../../util/util";

const HomePage = () => {
  isScript();

  const { t } = useTranslation("home");
  const { t: isLang } = useTranslation("type");

  return (
    <>
      <main className="main home">
        {/*<PopupAward />*/}
        <section className="banner-main">
          <div className="dim"></div>
          <div className="bg-video">
            <video
              className="bg-default"
              width="100%"
              height="100%"
              playsInline
              autoPlay
              muted
              loop
            >
              <source src="./assets/video/RePl_main_vod.mp4" type="video/mp4" />
            </video>
          </div>
          <div className="content-txt">
            <img
              className="logo fade-up"
              src="./assets/logo/logo_wh.png"
              alt="Ready Play Logo"
            />
            <h2 className="description fade-up">
              {t("banner.mainTit")}
              <br />
              {t("banner.subTit")}
            </h2>
            <div className="fade-up downloadAppPc">
              <button
                type="button"
                className="btn-main open"
                data-modal="download-mobile-app"
              >
                {t("banner.downloadMobileApp")}
              </button>
              <a
                className="btn-main"
                target="_blank"
                href={t("banner.downloadiOSAppUrl")}
              >
                {t("banner.downloadiOSApp")}
              </a>
              <a
                className="btn-main open"
                target="_blank"
                href="https://repl-downloads.s3.ap-northeast-2.amazonaws.com/live/Repl_Windows.msi"
                download
              >
                {t("banner.downloadPcApp")}
              </a>
              <button
                type="button"
                className="btn-main open"
                data-modal="download-macOS"
              >
                {t("banner.downloadMacOSApp")}
              </button>
            </div>

            <div className="fade-up downloadAppMobile">
              <a className="btn-main open" target="_blank" href="#" download>
                {t("banner.downloadMobileApp")}
              </a>
              <a
                className="btn-main"
                target="_blank"
                href={t("banner.downloadiOSAppUrl")}
              >
                {t("banner.downloadiOSApp")}
              </a>
            </div>
          </div>
        </section>

        <section className="event container">
          <div className="inner">
            <div className="swiper-box fade-up">
              <div className="swiper-container" id="event">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-09"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_09.png"
                          alt="한국문화체험, 정선 아리랑 이벤트"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.jsar")}</p>
                        <p className="event__desc">{t("event.jsar_desc")}</p>
                        <p className="event__date">2022.11.09 ~ Ongoing</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-07"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_07.png"
                          alt="우체국금융개발원 비전선포식"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.posid")}</p>
                        <p className="event__desc">{t("event.posid_desc")}</p>
                        <p className="event__date">2022.11.08</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-08"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_08.png"
                          alt="독도의 날, 플래시몹 이벤트"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.dokdo")}</p>
                        <p className="event__desc">{t("event.dokdo_desc")}</p>
                        <p className="event__date">2022.10.25 ~ Ongoing</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-06"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_06.png"
                          alt="KME & KMF 2022"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.kmes")}</p>
                        <p className="event__desc">{t("event.kmes_desc")}</p>
                        <p className="event__date">2022.10.13 ~ 2022.10.15</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-05"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_05.png"
                          alt="K-Metaverse Expo Busan 2022"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.kmeb")}</p>
                        <p className="event__desc">{t("event.kmeb_desc")}</p>
                        <p className="event__date">2022.08.25 ~ 2022.08.27</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-04"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_04.png"
                          alt="아리랑 국제방송 메타버스 미디어관 생중계"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.arir")}</p>
                        <p className="event__desc">{t("event.arir_desc")}</p>
                        <p className="event__date">2022.03.01 ~ 2022.03.31</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-01"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_01.png"
                          alt="숭실대학교 메타버스 입학상담"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.ssu")}</p>
                        <p className="event__desc">{t("event.ssu_desc")}</p>
                        <p className="event__date">2022.02.07 ~ Ongoing</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-02"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_02.png"
                          alt="대구 경원고등학교 온라인 축제"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.gwhs")}</p>
                        <p className="event__desc">{t("event.gwhs_desc")}</p>
                        <p className="event__date">2021.11.26</p>
                      </section>
                    </button>
                  </div>
                  <div className="swiper-slide">
                    <button
                      type="button"
                      data-modal="event-pop-03"
                      className="event__link open"
                    >
                      <section className="event__img">
                        <img
                          src="./assets/img/event_03.png"
                          alt="인천 창조경제혁신센터"
                        />
                      </section>
                      <section className="event__title">
                        <p className="event__name">{t("event.ccei")}</p>
                        <p className="event__desc">{t("event.ccei_desc")}</p>
                        <p className="event__date">2021.11.16</p>
                      </section>
                    </button>
                  </div>
                </div>
              </div>
              <div className="pagination-ev swiper-pagination-horizontal"></div>
              <div className="btn-prev-ev">
                <ion-icon name="chevron-back-outline"></ion-icon>
              </div>
              <div className="btn-next-ev">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </div>
            </div>
          </div>
        </section>

        <section className="promotion-video">
          <div className="dim"></div>
          <div className="bg-video">
            <video
              className="bg-default"
              width="100%"
              height="100%"
              playsInline
              muted
              autoPlay
              loop
            >
              <source src="assets/video/RePl_promo_vod.mp4" type="video/mp4" />
            </video>
          </div>
          <h2 className="main-tit fade-up">{t("promo.phrase")}</h2>
        </section>

        <section className="service container">
          <div className="inner">
            <h2 className="main-tit fade-up">{t("service.mainTit")}</h2>
            <ul className="service__wrapper">
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_01.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>{t("service.subTit_01")}</p>
                </div>
                <p className="service__desc">{t("service.text_01")}</p>
              </li>
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_02.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>{t("service.subTit_02")}</p>
                </div>
                <p className="service__desc">{t("service.text_02")}</p>
              </li>
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_03.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>{t("service.subTit_03")}</p>
                </div>
                <p className="service__desc">{t("service.text_03")}</p>
              </li>
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_04.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>{t("service.subTit_04")}</p>
                </div>
                <p className="service__desc">{t("service.text_04")}</p>
              </li>
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_05.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>{t("service.subTit_05")}</p>
                </div>
                <p className="service__desc">{t("service.text_05")}</p>
              </li>
              <li className="service__item fade-up">
                <img
                  className="service__img"
                  src="./assets/img/service_06.png"
                  alt="Ready Play's Service"
                />
                <div className="service__tit">
                  <p>
                    {t("service.subTit_06")}{" "}
                    <span className="option">OPTION</span>
                  </p>
                </div>
                <p className="service__desc">{t("service.text_06")}</p>
              </li>
            </ul>
            <a
              className="btn-full fade-up"
              target="_blank"
              href={`./assets/files/readyplay_brochure_${
                isLang("lang") === "kr" ? "kor" : "eng"
              }.pdf`}
            >
              <span className="icon-download"></span>Download Brochures
            </a>
          </div>
        </section>

        <section className="devices container">
          <div className="inner">
            <h2 className="main-tit fade-up">{t("devices.mainTit")}</h2>
            <article className="pc fade-up">
              <h3 className="sub-tit">PC</h3>
              <p className="devices__desc">
                {t("devices.pcDesc_01")}
                <br />
                {t("devices.pcDesc_02")}
              </p>
              <div className="table-wrapper">
                <div className="column">
                  <div className="tit">
                    <b>{t("devices.pcConfig_category_tit")}</b>
                  </div>
                  <div>{t("devices.pcConfig_category_01")}</div>
                  <div>{t("devices.pcConfig_category_02")}</div>
                  <div>{t("devices.pcConfig_category_03")}</div>
                  <div>{t("devices.pcConfig_category_04")}</div>
                  <div>{t("devices.pcConfig_category_05")}</div>
                  <div>{t("devices.pcConfig_category_06")}</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>{t("devices.pcMinConfig_tit")}</b>
                  </div>
                  <div>{t("devices.pcMinConfig_desc_01")}</div>
                  <div>{t("devices.pcMinConfig_desc_02")}</div>
                  <div>{t("devices.pcMinConfig_desc_03")}</div>
                  <div>{t("devices.pcMinConfig_desc_04")}</div>
                  <div>{t("devices.pcMinConfig_desc_05")}</div>
                  <div>{t("devices.pcMinConfig_desc_06")}</div>
                </div>
                <div className="column">
                  <div className="tit">
                    <b>{t("devices.pcRecConfig_tit")}</b>
                  </div>
                  <div>{t("devices.pcRecConfig_desc_01")}</div>
                  <div>{t("devices.pcRecConfig_desc_02")}</div>
                  <div>{t("devices.pcRecConfig_desc_03")}</div>
                  <div>{t("devices.pcRecConfig_desc_04")}</div>
                  <div>{t("devices.pcRecConfig_desc_05")}</div>
                  <div>{t("devices.pcRecConfig_desc_06")}</div>
                </div>
              </div>

              <div className="swiper-box">
                <div className="swiper-container" id="pcApp">
                  <ul className="swiper-wrapper">
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_01.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_02.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_03.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_04.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_05.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_06.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/pc_app_07.png"
                          alt="Supported For PC App"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btn-prev-pc">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div className="btn-next-pc">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </div>
              </div>
            </article>

            <article className="mobile fade-up">
              <h3 className="sub-tit">
                Mobile (Android, iOS)
                <small className="block">: {t("devices.mobileConfig")}</small>
              </h3>
              <p className="devices__desc">
                {t("devices.mobileDesc_01")}
                <br />
                {t("devices.mobileDesc_02")}
              </p>
              <div className="swiper-box">
                <div className="swiper-container" id="mobile">
                  <ul className="swiper-wrapper">
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_01.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_02.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_03.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_04.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_05.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/mobile_06.png"
                          alt="Supported For Mobile"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btn-prev-mb">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div className="btn-next-mb">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </div>
              </div>
            </article>

            <article className="vr fade-up">
              <h3 className="sub-tit">VR</h3>
              <p className="devices__desc">
                {t("devices.vrDesc_01")}
                <br />
                {t("devices.vrDesc_02")}
              </p>
              <div className="swiper-box">
                <div className="swiper-container" id="vr">
                  <ul className="swiper-wrapper">
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_01.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_02.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_03.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_04.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_05.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_06.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_07.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                    <li className="swiper-slide">
                      <div className="dev__img">
                        <img
                          src="./assets/img/vr_08.png"
                          alt="Supported For VR"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="btn-prev-vr">
                  <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div className="btn-next-vr">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </div>
              </div>
            </article>
          </div>
        </section>
      </main>
      {/* Modal For App Download  */}
      <div className="modal hidden" id="download-mobile-app">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("qr.title")}</h2>
              <p>{t("qr.caption")}</p>
            </section>
          </div>
          {/* modal__header*/}
          <div className="modal__content">
            <img
              className="qr-download"
              src="./assets/img/qr_download.png"
              alt="앱 다운로드"
            />
          </div>
        </div>
      </div>
      {/* Modal For macOS Download  */}
      <div className="modal hidden" id="download-macOS">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("macOS.title")}</h2>
              <p>{t("macOS.caption")}</p>
            </section>
          </div>
          {/* modal__header*/}
          <div className="modal__content">
            <a
              className="btn-main"
              target="_blank"
              href="https://repl-homepage.s3.ap-northeast-2.amazonaws.com/ready-play-react/assets/files/ReadyPlay.dmg"
              download
            >
              {t("macOS.button")}
            </a>
          </div>
        </div>
      </div>
      {/* // Modal For Event01  */}
      <div className="modal hidden" id="event-pop-01">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_ssu_tit")} SSU-PARK</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_01.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.02.07 ~ Ongoing</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_ssu_txt")}</p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event02 */}
      <div className="modal hidden" id="event-pop-02">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_gwhs_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_02.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2021.11.26</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_gwhs_txt")}</p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event03 */}
      <div className="modal hidden" id="event-pop-03">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_ccei_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_03.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2021.11.16</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_ccei_txt")}</p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event04 */}
      <div className="modal hidden" id="event-pop-04">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_arir_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_04.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.03.01 ~ 2022.03.31</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_arir_txt")}</p>
              <p className="modal__details--tit">{t("event.link")}</p>
              <p className="modal__details--txt">
                <a target="_blank" href="https://url.kr/697hms">
                  {t("event.link_txt")}{" "}
                  <ion-icon name="link-outline"></ion-icon>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event05 */}
      <div className="modal hidden" id="event-pop-05">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_kmeb_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_05.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.08.25 ~ 2022.08.27</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_kmeb_txt")}</p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event06 */}
      <div className="modal hidden" id="event-pop-06">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_kmes_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_06.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.10.13 ~ 2022.10.15</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_kmes_txt")}</p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event07 */}
      <div className="modal hidden" id="event-pop-07">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_posid_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_07.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.11.08</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">
                {t("event.popup_posid_txt")}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event08 */}
      <div className="modal hidden" id="event-pop-08">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_dokdo_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_08.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.10.25 ~ Ongoing</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">
                {t("event.popup_dokdo_txt")}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Modal For Event09 */}
      <div className="modal hidden" id="event-pop-09">
        <div className="modal__overlay"></div>
        <div className="modal__wrapper small-ex zoomIn">
          <div className="modal__header">
            <button className="close" type="button">
              <ion-icon name="close-outline"></ion-icon>
            </button>
            <section className="modal__tit">
              <h2>{t("event.popup_jsar_tit")}</h2>
            </section>
          </div>
          {/* modal__header */}
          <div className="modal__content">
            <div className="modal__content--img">
              <img src="./assets/img/event_09.png" alt="" />
            </div>
            <div className="modal__details">
              <p className="modal__details--tit">{t("event.date")}</p>
              <p className="modal__details--txt">2022.11.09 ~ Ongoing</p>
              <p className="modal__details--tit">{t("event.details")}</p>
              <p className="modal__details--txt">{t("event.popup_jsar_txt")}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
